<template>
  <div class="page">
    <el-tabs v-model="activeTab" class="tabs">
      <el-tab-pane label="周目标" name="week">
        <WeekPage v-if="visitedTabs.week" />
      </el-tab-pane>
      <el-tab-pane label="半年目标" name="half-year">
        <HalfYearPage v-if="visitedTabs.halfYear" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import WeekPage from './week.vue'
import HalfYearPage from './half-year.vue'

@Component({
  components: {
    WeekPage,
    HalfYearPage,
  }
})
export default class SalesPerformanceTargetIndex extends Vue {
  activeTab = 'week'
  visitedTabs = {
    week: false,
    halfYear: false,
  }

  created() {
    // 从URL query参数初始化activeTab
    this.initActiveTabFromQuery()

    // 监听 activeTab 变化，更新 visitedTabs 和 URL
    this.$watch('activeTab', (newTab) => {
      this.updateUrlQuery(newTab)
      // 标记tab为已访问，触发组件加载
      const visitedKey = newTab === 'half-year' ? 'halfYear' : newTab
      this.$set(this.visitedTabs, visitedKey, true)
    }, { immediate: true })
  }

  /**
   * 从URL query参数初始化activeTab
   */
  initActiveTabFromQuery() {
    const queryTab = this.$route.query.tab
    if (queryTab && ['week', 'half-year'].includes(queryTab)) {
      this.activeTab = queryTab
    }
  }

  /**
   * 更新URL query参数
   */
  updateUrlQuery(tab) {
    if (this.$route.query.tab !== tab) {
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          tab
        }
      })
    }
  }
}

export const route = [
  {
    path: '/sales_performance_target',
    name: 'sales_performance_target.index',
    component: SalesPerformanceTargetIndex,
    meta: {
      can: 'teams.read_perfomance',
      title: '销售业绩目标进度表',
    }
  },
]
</script>

<style lang="scss" scoped>
.page {
  height: 100%;
  padding: 0 15px;

  .tabs {
    height: 100%;
    display: flex;
    flex-direction: column;

    ::v-deep .el-tabs__content {
      flex: 1;
      overflow: hidden;
    }

    ::v-deep .el-tab-pane {
      height: 100%;
      overflow: hidden;
    }
  }
}
</style>
